import { render, staticRenderFns } from "./RsaSchedaPsicologicaHospiceEditComponent.vue?vue&type=template&id=423aeb62"
import script from "./RsaSchedaPsicologicaHospiceEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPsicologicaHospiceEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports